// Application-test.js

const data = {
    host: "https://testapi.yourright.com.cn",
    imageUploadHost: "https://testapi.yourright.com.cn",
    imagePreviewHost: "https://static.yourright.com.cn",
    appId: "1305198331571605504",
    version: "1.0.0",
    platform: "WinDeal-Admin",
    homePath: "/",
    loginPath: "/login/index",
    registerPath: "/register/index",
    tokenKey: "business_website_token_",
};

export default data;
